export default "__VITE_ASSET__aRgl27N9__"